// CategoryNode.js
import React, { useState } from 'react';
import { useCategoryTree } from '../../context/CategoryTreeContext';
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import ConfirmModal from "../Basic/ConfirmModal";

const CategoryNode = ({ category, level = 0, onLoadChildren, onAddChild, onEdit, onView, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [hover, setHover] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const {
    isCategoryExpanded,
    toggleCategory,
    getChildrenForCategory
  } = useCategoryTree();

  const hasChildren = category.has_children;
  const expanded = isCategoryExpanded(category.id);
  const children = expanded ? getChildrenForCategory(category.id) : [];

  const handleToggle = async () => {
    if (!expanded && children.length === 0) {
      setLoading(true);
      try {
        await onLoadChildren(category.id);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    toggleCategory(category.id);
  };

  const paddingRight = level * 20;

  const handleAddChild = (category) => {
  if (category.has_product && !category.has_children) {
    setSelectedCategory(category);
    setShowModal(true);
  } else {
    onAddChild(category);
  }
};




  return (
    <div>

      <div
        className="flex items-center gap-3 py-2 px-3 hover:bg-gray-50 rounded group"
        style={{ paddingRight }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {hasChildren ? (
          <button onClick={handleToggle} className="w-6 h-6 flex items-center justify-center">
            {loading ? <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin" /> :
              <svg className={`w-4 h-4 transform ${expanded ? 'rotate-90' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M9 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>}
          </button>
        ) : <div className="w-6" />}

        <div className="w-8 h-8 bg-blue-50 rounded flex items-center justify-center text-blue-600">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <div className="text-sm font-medium text-gray-900 truncate">{category.name}</div>
            {!category.is_active && <div className="text-xs text-[#E53935] px-2">غیرفعال</div>}
            {!hasChildren && <div className="text-xs text-[#4CAF50] px-2">آخرین سطح</div>}
          </div>
          <div className="text-xs text-gray-500">کد: {toPersianNumbers(category.code)}</div>
        </div>

        <div className={`flex items-center gap-[2px] transition-opacity`}>
          <button onClick={() => onView(category)} title="مشاهده" className=" w-[28px] h-[28px] p-[0px] text-[#2B5388] hover:text-blue-600">👁</button>
          <button onClick={() => handleAddChild(category)} title="افزودن" className="w-[28px] h-[28px] p-[0px] text-[#2B5388] hover:text-green-600">＋</button>
          <button onClick={() => onEdit(category)} title="ویرایش" className="w-[28px] h-[28px] p-[0px] text-[#2B5388] hover:text-yellow-600">✎</button>
          <button onClick={() => onDelete(category)} title="حذف" className="w-[28px] h-[28px] p-[0px] text-[#2B5388] hover:text-red-600">🗑</button>
        </div>
        <ConfirmModal
          isOpen={showModal}
          message={`آیا از ایجاد زیردسته برای دسته "${category.name}" مطمئن هستید؟` }
          note={` توجه: دسته ${category.name} دارای کالای تخصیص داده شده است، همه کالاها به زیردسته جدید انتقال داده می‌شوند.`}
          onConfirm={() => {
            onAddChild(selectedCategory);
            setShowModal(false);
          }}
          onClose={() => setShowModal(false)}
        />
      </div>

      {expanded && children.length > 0 && (
        <div className="pl-4 border-l border-gray-100">
          {children.map((c) => (
            <CategoryNode
              key={c.id}
              category={c}
              level={level + 1}
              onLoadChildren={onLoadChildren}
              onAddChild={onAddChild}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryNode;